import * as moment from "moment/moment";

export default {
  data() {
    return {
      popIndex: null,
      users: [],
      manageByUsers: [],
      manage_by: [],
      year: [],
      resourceLoader: false,
      date: `${moment().endOf("month").format("YYYY")}-${moment().quarter()}`,
      selectedReport: null,
      quarterItems: [],
      editFields: {
        projects_added: null,
        projects_closed: null,
        dedicated_devs_added: null,
        dedicated_devs_closed: null,
        notes: null,
      },
    };
  },

  computed: {
    filterUserOptions() {
      return this.manageByUsers;
    },
  },
  watch: {
    manage_by() {
      this.quarterlyResourceList();
    },
    date() {
      this.quarterlyResourceList();
    },
  },

  mounted() {
    const queryParams = this.$route.query;
    if (queryParams && Object.keys(queryParams).length > 0) {
      if (queryParams.manage_by) {
        this.manage_by = queryParams.manage_by.split(',').filter(Boolean);
      }
      if (queryParams.date) {
        this.date = queryParams.date;
      }
    }

    this.quarterlyResourceList();
    this.fetchManagingUsers();
  },

  methods: {
    resetFilterState() {
      this.manage_by = [];
      this.date = `${moment().endOf("month").format("YYYY")}-${moment().quarter()}`;
    },

    updateQueryParams() {
      const query = this.getQueryParams();
      this.routeQueryUpdate(query);
    },

    getQueryParams() {
      const queryParams = {
        manage_by: Array.isArray(this.manage_by) && this.manage_by.length > 0 ? this.manage_by.join(",") : null,
        date: this.date,
      };

      return Object.keys(queryParams).reduce((acc, key) => {
        if (queryParams[key]) acc[key] = queryParams[key];
        return acc;
      }, {});
    },

    async fetchManagingUsers() {
      const response = await this.getHTTPPostResponse(
        "admin/master/user/resource-managing-user-list",
        {}
      );
      if (response && response.data) {
        const users = response.data.user || [];
        this.manageByUsers = users.map((user) => ({
          value: user.id,
          label: user.full_name,
          name: user.full_name,
        }));
      }
    },

    openEditModal(report) {
      this.selectedReport = report;
      this.editFields = {
        projects_added: report.projects_added || 0,
        projects_closed: report.projects_closed || 0,
        dedicated_devs_added: report.dedicated_devs_added || 0,
        dedicated_devs_closed: report.dedicated_devs_closed || 0,
        notes: report.notes || null,
      };
      this.popIndex = report.id;
      this.$bvModal.show("resource-modal");
    },

    async submitFieldUpdate() {
        const payload = { ...this.editFields };
        const response = await this.getHTTPPostResponse(
          `/querterly-resource-report/update/${this.selectedReport.id}`,
          payload,
          true
        );
      
        if (response && response.status === 200) {      
          this.$bvModal.hide("resource-modal");
          this.quarterlyResourceList(false);
        }
        this.resetModal();
    },
      
    resetModal() {
      this.popIndex = null;
      this.selectedReport = null;
      this.editFields = {
        projects_added: null,
        projects_closed: null,
        dedicated_devs_added: null,
        dedicated_devs_closed: null,
        notes: null,
      };
    },

    async quarterlyResourceList(isLoaderEffect = true) {
      const month = moment(this.date, "YYYY-M").format("M");
      const months = this.getQuarterMonth(month);
      this.quarter = this.generateMonthLabels(months);
      this.resourceLoader = isLoaderEffect;

      this.updateQueryParams();

      const input = {
        months: months,
        year: moment(this.date, "YYYY-M").format("YYYY"),
        manage_by: this.manage_by,
      };
      const response = await this.getHTTPPostResponse(
        "/querterly-resource-report",
        input,
        false
      );
      if (response && response.data) {
        this.quarterItems = response.data;
      }
      this.resourceLoader = false;
    },

    reportMonthFormat(date) {
      return moment(date, "M-YYYY").format("MMMM-YY");
    },

    reportQuarterFormat(month, year) {
      const quarter = Math.floor((month - 1) / 3) + 1;
      return `Q${quarter}-${year}`;
    },

    reDirectTab(report) {
      this.$router.push({
        name: 'quarterResourceReportDetails',
        params: {
          id: report.id,
        },
        query: {
          date: this.reportMonthFormat(report.month, report.year),
        }
      }).catch(err => {
        // Ignore the NavigationDuplicated error
        if (err.name !== 'NavigationDuplicated') {
          console.log(err)
        }
      })
    },
  },
};
